module.exports = __webpack_public_path__ + "static/media/imgNoticiaBig.b02eba67.jpg";